import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AccountService } from "src/app/shared/services/account/account.service";

@Injectable({
  providedIn: "root",
})
export class TeacherGuard {
  constructor(private accountService: AccountService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.accountService.getAuthenticatedMember().pipe(
      map((member) => {
        if (member === null) {
          return this.accountService.createLoginUrlTree();
        }

        return member.is_teacher
          ? true
          : this.accountService.createMemberHomeUrlTree(member);
      }),
      catchError(() => of(this.accountService.createLoginUrlTree())),
    );
  }
}
